import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import SolvedFilter from '../components/SolvedFilter';
export default function extendIndexPage() {
  extend(IndexSidebar.prototype, 'items', function (items) {
    var _tag$isQnA;
    const tag = app.currentTag();
    if (!(tag != null && (_tag$isQnA = tag.isQnA) != null && _tag$isQnA.call(tag))) return;
    const canStartDiscussion = app.forum.attribute('canStartDiscussion') || !app.session.user;
    if (!items.has('newDiscussion')) return;
    const cta = items.get('newDiscussion');
    const label = app.translator.trans(canStartDiscussion ? 'fof-best-answer.forum.index.ask_question' : 'fof-best-answer.forum.index.cannot_ask_question');
    cta.children = label;
    cta.attrs['aria-label'] = label;
  });
  extend(IndexPage.prototype, 'viewItems', function (items) {
    const currentTag = app.currentTag();
    if (!currentTag) return;
    items.add('solved-filter', m(SolvedFilter, {
      currentTag: currentTag
    }));
  });
}
flarum.reg.add('fof-best-answer', 'forum/extenders/extendIndexPage', extendIndexPage);